import React, { useEffect, useRef } from 'react';

function CmsContent(props) {
  let { block } = props;

  let htmlContent = block?.body;

  const contentRef = useRef(null);

  useEffect(() => {
    if (contentRef.current) {
      // Clear existing content to prevent double execution if re-rendering
      contentRef.current.innerHTML = '';

      const parsedContent = document.createRange().createContextualFragment(htmlContent);
      contentRef.current.appendChild(parsedContent);

      // Manually execute scripts if they are not executed automatically
      // This might be necessary for some dynamic scripts
      const scripts = contentRef.current.querySelectorAll('script');
      scripts.forEach(script => {
        const newScript = document.createElement('script');
        if (script.src) {
          newScript.src = script.src;
        } else {
          newScript.textContent = script.textContent;
        }
        script.parentNode.replaceChild(newScript, script); // Replace old script with new to ensure execution
      });
    }
  }, [htmlContent]);

  return (
    <div ref={contentRef} dangerouslySetInnerHTML={{ __html: htmlContent }} />
  );
}

export default CmsContent;
